"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "castellalto": {
    "fff3d605": [{
      "hkey": "1d59f9da",
      "slug": "feudo-alto",
      "name": "Feudo Alto",
      "primary": true,
      "skipSearch": false
    }],
    "feudo": [{
      "hkey": "1d59f9da",
      "slug": "feudo-alto",
      "name": "Feudo Alto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "44d1c7b0": [{
      "hkey": "77f6491d",
      "slug": "petriccione-villa-torre-villa-zaccheo",
      "name": "Petriccione-Villa Torre-Villa Zaccheo",
      "primary": true,
      "skipSearch": false
    }],
    "petriccione": [{
      "hkey": "77f6491d",
      "slug": "petriccione-villa-torre-villa-zaccheo",
      "name": "Petriccione-Villa Torre-Villa Zaccheo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "caad69af": [{
      "hkey": "8340de35",
      "slug": "castellalto",
      "name": "Castellalto",
      "primary": true,
      "skipSearch": false
    }],
    "pianvilla": [{
      "hkey": "8340de35",
      "slug": "castellalto",
      "name": "Castellalto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2e4fe069": [{
      "hkey": "77f6491d",
      "slug": "petriccione-villa-torre-villa-zaccheo",
      "name": "Petriccione-Villa Torre-Villa Zaccheo",
      "primary": true,
      "skipSearch": false
    }],
    "villa-torre": [{
      "hkey": "77f6491d",
      "slug": "petriccione-villa-torre-villa-zaccheo",
      "name": "Petriccione-Villa Torre-Villa Zaccheo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "castellalto"
    }]
  }
};
exports["default"] = _default;